export const composeSendButton = "S5a";
export default {composeSendButton};